import Http from '../api/http';

export default class Store extends Http {
  constructor() {
    super();
  }

  /**
   * 地址关键字搜索
   * @param {string} place -  地址关键字
   * @param {string} region -  搜索区域
   * @param {integer} pid -  父级id 1是国内 2是国外
   */

  store_searchPlace() {
    return super.post('store/searchPlace', ...arguments);
  }
}
